import { c as _c } from "react/compiler-runtime";
import { useContext, useMemo } from 'react';
import { IntlContext } from '@spa/lib/react/context/IntlContext';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import createNamespacedIntl from '@spa/lib/i18n/common/createNamespacedIntl';
const useNamespacedIntl = namespace => {
  const $ = _c(6);
  const contextValue = useContext(IntlContext);
  if (contextValue === null) {
    throw new Error("IntlContext must be provided.");
  }
  const {
    translationsByIdByNamespace,
    enableWarnings
  } = contextValue;
  let t0;
  if ($[0] !== translationsByIdByNamespace) {
    t0 = translationsByIdByNamespace ?? {};
    $[0] = translationsByIdByNamespace;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== enableWarnings || $[3] !== namespace || $[4] !== t0) {
    t1 = createNamespacedIntl(namespace, t0, enableWarnings);
    $[2] = enableWarnings;
    $[3] = namespace;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useNamespacedIntl;